<template>
  <div class="week-by-car-num">
    <div class="wrapper">
      <div class="header">
        <el-form :inline="true">
          <el-form-item label="统计月份">
            <el-date-picker
                v-model="formData.time"
                type="month"
                format="yyyy年MM月"
                value-format="yyyyMM"
                placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="省市区" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <!--                :props="{ label: 'provinceName', value: 'provinceCode', children: 'cityItem',checkStrictly: true }"-->

            <el-cascader
                v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                clearable></el-cascader>
          </el-form-item>
          <el-form-item label="开发记录" label-width="75px">
            <el-select v-model="formData.devLog" placeholder="请选择">
              <el-option
                  v-for="item in devLogOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="value1">
            <el-form-item label="" label-width="75px">
              <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
              <el-input v-model="formData.companyName" clearable placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="" label-width="75px">
              <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
              <el-input v-model="formData.cmpnanyDevUser" clearable placeholder="请输入开发人"></el-input>
            </el-form-item>
            <!--          <el-form-item label="" label-width="75px">-->
            <!--            &lt;!&ndash;            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>&ndash;&gt;-->
            <!--formData          </el-form-item>-->
            <!--            <el-form-item label="车机触达" label-width="75px">-->
            <!--              <el-select v-model="formData.reachStatus" placeholder="请选择">-->
            <!--                <el-option-->
            <!--                    v-for="item in reachStatusOptions"-->
            <!--                    :key="item.value"-->
            <!--                    :label="item.label"-->
            <!--                    :value="item.value">-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
<!--            <el-form-item label="客户状态" label-width="75px">-->
<!--              <el-select v-model="formData.companyCardStatus"-->
<!--                         multiple-->
<!--                         collapse-tags-->
<!--                         placeholder="请选择">-->
<!--                <el-option-->
<!--                    v-for="item in companyCardStatusOption"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="加油卡类型" label-width="85px">
              <el-select v-model="formData.cardType" placeholder="请选择">
                <el-option
                    v-for="item in cardTypeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆规模" label-width="75px">
              <el-select v-model="formData.vehicleCountMask" placeholder="请选择">
                <el-option
                    v-for="item in vehicleCountMaskOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运营公里数" label-width="85px">
              <el-select v-model="formData.mileageMask" placeholder="请选择">
                <el-option
                    v-for="item in mileageMaskOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="停靠石化油站次数占比">
              <el-select v-model="formData.percentage" placeholder="不限" style="width:110px;">
                <el-option label="不限" value></el-option>
                <el-option label="0-10%" value="0-10"></el-option>
                <el-option label="10-20%" value="10-20"></el-option>
                <el-option label="20-30%" value="20-30"></el-option>
                <el-option label="30-40%" value="30-40"></el-option>
                <el-option label="40-50%" value="40-50"></el-option>
                <el-option label="50-60%" value="50-60"></el-option>
                <el-option label="60-70%" value="60-70"></el-option>
                <el-option label="70-80%" value="70-80"></el-option>
                <el-option label="80-90%" value="80-90"></el-option>
                <el-option label="90%以上" value="90-100"></el-option>
              </el-select>
            </el-form-item>
            <!--          <el-form-item label="停靠石化油站次数占比" label-width="160px">-->
            <!--            <el-select v-model="formData" placeholder="请选择">-->
            <!--              <el-option-->
            <!--                  v-for="item in options"-->
            <!--                  :key="item.value"-->
            <!--                  :label="item.label"-->
            <!--                  :value="item.value">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <!--          </el-form-item>-->
          </template>
          <el-button style="margin-left:30px;" @click="onDebounceSearch" class="searchBtn">查询</el-button>
          <el-switch
              v-model="value1"
              style="margin-left: 10px"
              @change="changeSearch"
              active-text="展开"
              inactive-text="收起">
          </el-switch>

          <WeekDialog @on-command="onWeekDialogCommand" v-if="showWeekDialog"/>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50" fixed="left"/>
        <el-table-column prop="companyName" width="200" fixed label="企业名称" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.decryptedCompanyName">{{ scope.row.companyName }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer" @click="scope.row.decryptedCompanyName = true">{{
                  scope.row.companyNameMask
                }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="companyCreditCode" width="200" label="统一社会信用代码" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.companyCreditCodeIs">{{ scope.row.companyCreditCode }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer" @click="scope.row.companyCreditCodeIs = true">{{
                  scope.row.companyCreditCodeMask
                }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="oilConsumption" label="柴油量估算(吨)" width="150" align="center">
          <template slot="header" slot-scope="scope">
            <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
              <div class="proTextSty">
                根据企业名下所有运营柴油车辆对应吨位百公里油耗，乘以相应运营里程计算得出。1吨=1176升。下附车型油耗表。
              </div>
              <div class="tableTitleSty">车型油耗表</div>
              <el-table :data="gridData" border>
                <el-table-column width="185" align="center" property="date" label="车辆吨位区间"></el-table-column>
                <el-table-column align="center" property="name" label="平均每百公里油耗(升)"></el-table-column>
              </el-table>
              <span slot="reference">
                <span style="margin-right: 5px">柴油量估算(吨)</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="vehicleOperatorCount" label="运营车辆数" width="100" align="center"></el-table-column>
        <el-table-column prop="petrochemicalStopRadio" label="停靠石化油站次数占比" width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{
                scope.row.petrochemicalStopRadio && scope.row.petrochemicalStopRadio != '-' ? scope.row.petrochemicalStopRadio + '%' : scope.row.petrochemicalStopRadio
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="petrochemicalStopRadio" label="停靠石化油站次数环比" width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{
                scope.row.petrochemicalStopRadioMom && scope.row.petrochemicalStopRadioMom != '-' ? scope.row.petrochemicalStopRadioMom + '%' : scope.row.petrochemicalStopRadioMom
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="petrochemicalStopCount" label="S级油站停靠次数" align="center"></el-table-column>
        <el-table-column prop="petroleumStopCount" label="C级油站停靠次数" align="center"></el-table-column>
        <el-table-column prop="otherStopCount" label="E级油站停靠次数" align="center"></el-table-column>
        <el-table-column prop="cardTypeText" label="加油卡类型" width="100" align="center"></el-table-column>
        <el-table-column prop="cardCount" label="联名卡办卡数量" width="150" align="center"></el-table-column>
        <el-table-column prop="lastOpetime" label="最后一次联名卡消费时间" width="200" align="center"></el-table-column>
        <el-table-column prop="" label="近6个月平均消费" width="150" align="center"></el-table-column>
        <el-table-column label="办卡信息" align="center">
          <template slot-scope="scope">
            <span style="color:#1137FF;cursor: pointer;" @click="toDetail(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="provname" label="所属省份" align="center"></el-table-column>
        <el-table-column prop="cityname" label="所属城市" align="center"></el-table-column>
        <el-table-column prop="countyname" label="所属区县" align="center"></el-table-column>
        <el-table-column prop="runProvince" label="常运营省份按里程取TOP3" width="250" align="center"></el-table-column>
        <el-table-column prop="runProvince" label="停靠加油站TOP5" width="250" align="center">
          <template slot-scope="scope">
            <!--            <span v-if="scope.row.companyAddress==null">-</span>-->
            <!--            <span v-else style="color:#1137FF;cursor: pointer;" @click="toDetail(scope.row)">查看</span>-->
            <span style="color:#1137FF;cursor: pointer;" @click="seeTopFive(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyCardStatusText" label="客户状态" width="170" align="center">
          <template slot="header" slot-scope="scope">
            <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
              <div class="proTextSty">
                联名卡在用客户：近6个自然月有联名卡消费或有新增办卡的客户，对于非联名卡在用客户将根据其名下车辆停靠中国石化加油站占比区间定义客户状态为潜在新客户[0~10%)，摇摆客户[10%~20%)，低忠诚客户[20%~30%)，中忠诚客户[30%~50%)，高忠诚客户[50%~100%]。
              </div>
              <span slot="reference">
                <span style="margin-right: 5px">客户状态</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="companyDevStatusText" label="开发状态" align="center"></el-table-column>
        <el-table-column prop="devUser" label="开发人" align="center"></el-table-column>
        <el-table-column prop="cmpnanyDevStartTime" width="150" label="开发开始时间" align="center"></el-table-column>
        <el-table-column prop="cmpnanyDevEndTime" width="150" label="开发结束时间" align="center"></el-table-column>
        <el-table-column prop="reachStatusText" label="车机触达" align="center"></el-table-column>
        <el-table-column prop="vehicleCountMask" label="车辆规模" width="100" align="center"></el-table-column>
        <el-table-column prop="mileageMask" label="运营公里数" width="150" align="center"></el-table-column>
        <el-table-column prop="isRecord" fixed="right" width="150" align="center" label="开发记录">
          <template slot-scope="scope">
            <span v-if="scope.row.isRecord===1" style="color:#1137FF;cursor: pointer;" @click="seeDevLog(scope.row)">查看</span>
            <span v-else>-</span>
            <!--            <span style="color:#1137FF;cursor: pointer;" @click="seeDevLog(scope.row)">查看</span>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBlock">
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       @size-change="handleSizeChange"
                       :page-sizes="[50,100, 200]"
                       layout="prev, pager, next, jumper, sizes" :total="total" style="margin:auto;"></el-pagination>
      </div>

      <detailCard @changeDetail="changeDetail" :isEdit="false" :nrData="nrData" v-if="isShowMes"></detailCard>
      <!--  开发记录   -->
      <devLog @closeTask="closeProAll" :currRow="currRow" v-if="devLogIs"></devLog>
      <!--  加油站Top5   -->
      <seeTopFive @closeTask="closeProAll" :currRow="currRow" v-if="seeTopFiveIs"></seeTopFive>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import _ from 'lodash'
// import areaList from './components/areaList'
import detailCard from '@/components/detailCard.vue'
import WeekPopover from '../../freight/weekByCarNum/components/weekPopover.vue'
import WeekDialog from '../../freight/weekByCarNum/components/weekDialog.vue'
import Util from '@/utils/util'
import devLog from "components/devLog.vue";
import seeTopFive from "components/seeTopFive.vue";

export default {
  name: 'week-by-car-num',
  components: {seeTopFive, devLog, WeekPopover, WeekDialog, detailCard},
  data() {
    return {
      devLogIs: false,
      seeTopFiveIs: false,
      tableHeight1: this.tableHeight,
      nrData: {},
      value1: false,
      isShowMes: false,
      showWeekDialog: false,
      gridData: Util.gridData,
      reachStatusOptions: Util.reachStatusOptions,
      companyCardStatusOption: Util.companyCardStatusOption,
      devStatusOption: Util.devStatusOption,
      cardTypeOption: Util.cardTypeOption,
      vehicleCountMaskOption: Util.vehicleCountMaskOption,
      mileageMaskOption: Util.mileageMaskOption,
      devLogOption: Util.devLogOption,
      formData: {
        companyCardStatus: [''],
        cmpnanyDevUser: '',
        companyName: '',
        provCityCounty: '',
        provCode: '',
        devLog: '',
        cityCode: '',
        countyCode: '',
        time: '',
        cardType: '',
        vehicleCountMask: '',
        mileageMask: '',
        reachStatus: '',
        percentage: ''
      },
      tableCol: [
        {
          name: '运营车辆数',
          children: [
            {name: '全部车辆', prop: 'runCarNum0'},
            {name: '柴油车辆', prop: 'runCarNum1'},
            {name: 'LNG车辆', prop: 'runCarNum2'},
            {name: '新能源车辆', prop: 'runCarNum3'},
          ],
        },
        {
          name: '运营里程',
          children: [
            {name: '全部车辆', prop: 'totalMile0'},
            {name: '柴油车辆', prop: 'totalMile1'},
            {name: 'LNG车辆', prop: 'totalMile2'},
            {name: '新能源车辆', prop: 'totalMile3'},
          ],
        },
      ],

      curDate: '',

      tableData: [],

      onDebounceSearch: _.debounce(this.onSearch, 500),
      total: 0, // 总页数
      index: 1, // 当前页数
      pageSize: 50,
      areaListPr: ''
    }
  },
  // computed: {
  //   areaList() {
  //     let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
  //     if (nerArr.length > 0) {
  //       nerArr.forEach(item => {
  //         // item.provinceCode = item.provinceCode + '0000'
  //         item.value = item.provinceCode + '0000'
  //         item.label = item.provinceName
  //         // if (item.cityItem.length > 0) {
  //         //   item.cityItem.forEach(itemChen => {
  //         //     itemChen.provinceCode = itemChen.cityCode
  //         //     itemChen.provinceName = itemChen.cityName
  //         //   })
  //         // }
  //       })
  //     }
  //     return nerArr
  //   },
  // },
  mounted() {
    // this.getListP()
    this.getPrInter()
    this.getData(1)
  },
  methods: {
    closeProAll(curr) {
      this[curr] = false
    },
    seeDevLog(row) {
      this.devLogIs = true
      this.currRow = row
    },
    seeTopFive(row) {
      this.seeTopFiveIs = true
      this.currRow = row
    },
    changeSearch() {
      if (this.value1) {
        this.tableHeight1 = this.tableHeight - 120
      } else {
        this.tableHeight1 = this.tableHeight
      }
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    getListP(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        resolve(nodes);
      })
    },
    toDetail(row) {
      this.isShowMes = true
      this.nrData = row
    },
    changeDetail() {
      this.isShowMes = false
    },
    onChangePage(index) {
      this.index = index
      this.getData(2)
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.index = 1
      this.getData(2)
    },
    onSearch() {
      this.index = 1
      this.total = 0
      this.getData(2)
    },
    getData(num = 2) {
      console.log(this.formData)
      if (num == 2 && this.formData.time == '') {
        this.$message({
          message: '请选择月份',
          type: 'warning',
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const params = {
        time: this.formData.time,
        page: this.index,
        pageSize: this.pageSize,
        isRecord: this.formData.devLog,
        provCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
        countyCode: this.formData.provCityCounty[2] || '',
        companyName: this.formData.companyName,
        devUser: this.formData.cmpnanyDevUser,
        reachStatus: this.formData.reachStatus,
        cardType: this.formData.cardType,
        vehicleCountMask: this.formData.vehicleCountMask,
        mileageMask: this.formData.mileageMask,
        percentage: this.formData.percentage,
        companyCardStatus: this.formData.companyCardStatus.length > 0 ? this.formData.companyCardStatus.join(',') : '',
      }

      // this.tableData = []
      http
          .cbCardFindPage(params)
          .then((e) => {
            loading.close();
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }

            if (e.data.length == 0) {
              this.tableData = []
              return;
            }
            if (e.data.time) {
              this.formData.time = e.data.time
            }

            e.data.pageInfo.dataList.forEach(item => {
              Object.keys(item).forEach(item2 => {
                if (item2 != 'citycode' && item2 != 'countycode') {
                  item[item2] = item[item2] || item[item2] === 0 ? item[item2] : '-'
                }
              })
            })
            this.tableData = e.data.pageInfo.dataList.map((_) => {
              _.decryptedCompanyName = false
              _.companyCreditCodeIs = false
              _.cmpnanyDevStartTime = _.devStartTime != '-' ? Util.format(new Date(_.devStartTime * 1).getTime(), "yyyy-MM-dd") : '-'
              _.cmpnanyDevEndTime = _.devEndTime != '-' ? Util.format(new Date(_.devEndTime * 1).getTime(), "yyyy-MM-dd") : '-'
              _.companyCardStatusText = this.getNmae(Util.companyCardStatusOption, _.companyCardStatus)
              _.companyDevStatusText = this.getNmae(Util.devStatusOption, _.devStatus)
              _.cardTypeText = this.getNmae(Util.cardTypeOption, _.cardType)
              _.reachStatusText = this.getNmae(Util.reachStatusOptions, _.reachStatus)
              return _
            })
            this.total = e.data.pageInfo.total
            this.index = e.data.pageInfo.pageNum
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
            loading.close();
          })
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.getData()
          break
        default:
          break
      }
    },

    onWeekDialogCommand(params) {
      switch (params.type) {
        case 'ok':
          window.location.assign(http.getWeekCarOperateExport(params.data))
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.proTextSty{
  font-size: 14px;
}
.tableTitleSty{
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}
.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    margin-bottom: 20px;
  }
}

/deep/ .el-table__empty-block {
  width: 100% !important;
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

.pageBlock {
  display: flex;
  margin-top: 20px;
}
</style>
<style lang="stylus">
.el-cascader-menu {
  overflow: hidden;
}
</style>
